import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const DynamicTemplateFormulaInformation = ({ dynamicTemplateFormulasList }) => {

    const dynamicTemplateFormulaColumns = [
      {
        field: "formulaDataId",
        headerName: "Formula Data ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "formulaDefinitionId",
        headerName: "Formula Definition ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "formula",
        headerName: "Formula",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "templateAssessmentId",
        headerName: "Template Assessment ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "templateId",
        headerName: "Template ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "label",
        headerName: "Label",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "value",
        headerName: "Value",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "modifiedBy",
        headerName: "Modified By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdDate",
        headerName: "Created Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.createdDate),
      },
      {
        field: "modifiedDate",
        headerName: "Modified Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.modifiedDate),
      },
    ];

        return(
            <AccordianContainer
            id="accord"
            title="Dynamic Template Formulas"
            initialOpen={false}
          >
            <Box sx={{ marginTop: "-0.5%" }}>
            <CustomDataGrid
              noDataMessage="No Data"
              rows={ validate(dynamicTemplateFormulasList) ?
                dynamicTemplateFormulasList.map((item, index) => ({
                  id: index + 1,
                  ...item,
                })) : []}
              columns={dynamicTemplateFormulaColumns}
              pageSize={15}
              pageSizeOptions={[10]}
              gridLazyLoad={() => {}}
              gridHeight={305}
              getRowId={(row) => row.formulaDataId}
              onCellKeyDown={(event, param) => {
                (param.key === "e" || param.key === "E") &&
                  param.preventDefault();
              }}
            />
            </Box>
            </AccordianContainer>
        );
}

export default DynamicTemplateFormulaInformation;